import { cn } from "../../lib/cn";

interface Props {
  name?: string;
  className?: string;
  color?: string;
}

/** Schematic furniture icons (top-down ish). Color tints them. */
export function CategoryIcon({ name, className, color }: Props) {
  const stroke = "currentColor";
  const fill = color ?? "currentColor";
  switch (name) {
    case "sofa":
      return (
        <svg viewBox="0 0 32 32" className={cn(className)}>
          <rect x="4" y="10" width="24" height="14" rx="3" fill={fill} opacity="0.18" />
          <rect x="4" y="10" width="24" height="14" rx="3" fill="none" stroke={stroke} strokeWidth="1.5" />
          <rect x="7" y="13" width="6" height="5" rx="1.5" fill={fill} opacity="0.4" />
          <rect x="14" y="13" width="6" height="5" rx="1.5" fill={fill} opacity="0.4" />
          <rect x="21" y="13" width="4" height="5" rx="1.5" fill={fill} opacity="0.4" />
        </svg>
      );
    case "armchair":
      return (
        <svg viewBox="0 0 32 32" className={cn(className)}>
          <rect x="7" y="10" width="18" height="14" rx="3" fill={fill} opacity="0.18" stroke={stroke} strokeWidth="1.5" />
          <rect x="10" y="13" width="12" height="6" rx="2" fill={fill} opacity="0.4" />
        </svg>
      );
    case "chair":
      return (
        <svg viewBox="0 0 32 32" className={cn(className)}>
          <rect x="10" y="8" width="12" height="16" rx="2" fill={fill} opacity="0.18" stroke={stroke} strokeWidth="1.5" />
          <line x1="10" y1="14" x2="22" y2="14" stroke={stroke} strokeWidth="1.5" />
        </svg>
      );
    case "table":
      return (
        <svg viewBox="0 0 32 32" className={cn(className)}>
          <rect x="6" y="11" width="20" height="10" rx="2" fill={fill} opacity="0.25" stroke={stroke} strokeWidth="1.5" />
        </svg>
      );
    case "bed":
      return (
        <svg viewBox="0 0 32 32" className={cn(className)}>
          <rect x="6" y="6" width="20" height="20" rx="2" fill={fill} opacity="0.18" stroke={stroke} strokeWidth="1.5" />
          <rect x="9" y="9" width="14" height="6" rx="1.5" fill={fill} opacity="0.5" />
        </svg>
      );
    case "bookshelf":
      return (
        <svg viewBox="0 0 32 32" className={cn(className)}>
          <rect x="8" y="5" width="16" height="22" fill={fill} opacity="0.18" stroke={stroke} strokeWidth="1.5" />
          <line x1="8" y1="12" x2="24" y2="12" stroke={stroke} strokeWidth="1" />
          <line x1="8" y1="18" x2="24" y2="18" stroke={stroke} strokeWidth="1" />
          <line x1="8" y1="24" x2="24" y2="24" stroke={stroke} strokeWidth="1" />
        </svg>
      );
    case "drawer":
      return (
        <svg viewBox="0 0 32 32" className={cn(className)}>
          <rect x="5" y="10" width="22" height="14" rx="1.5" fill={fill} opacity="0.18" stroke={stroke} strokeWidth="1.5" />
          <line x1="5" y1="17" x2="27" y2="17" stroke={stroke} strokeWidth="1" />
          <circle cx="16" cy="13.5" r="0.8" fill={stroke} />
          <circle cx="16" cy="20.5" r="0.8" fill={stroke} />
        </svg>
      );
    case "tv-stand":
      return (
        <svg viewBox="0 0 32 32" className={cn(className)}>
          <rect x="5" y="14" width="22" height="8" rx="1.5" fill={fill} opacity="0.25" stroke={stroke} strokeWidth="1.5" />
          <rect x="9" y="8" width="14" height="4" rx="1" fill="#1a1a1f" />
        </svg>
      );
    case "counter":
      return (
        <svg viewBox="0 0 32 32" className={cn(className)}>
          <rect x="4" y="9" width="24" height="14" rx="1.5" fill={fill} opacity="0.22" stroke={stroke} strokeWidth="1.5" />
          <line x1="4" y1="11.5" x2="28" y2="11.5" stroke={stroke} strokeWidth="1" opacity="0.75" />
          <rect x="11" y="14.5" width="10" height="6" rx="2" fill="none" stroke={stroke} strokeWidth="1.25" />
          <line x1="16" y1="14.5" x2="16" y2="16.2" stroke={stroke} strokeWidth="1.25" />
        </svg>
      );
    case "fridge":
      return (
        <svg viewBox="0 0 32 32" className={cn(className)}>
          <rect x="9" y="5" width="14" height="22" rx="1.5" fill={fill} opacity="0.3" stroke={stroke} strokeWidth="1.5" />
          <line x1="9" y1="13" x2="23" y2="13" stroke={stroke} strokeWidth="1" />
          <rect x="20" y="9" width="1.5" height="2" fill={stroke} />
          <rect x="20" y="18" width="1.5" height="3" fill={stroke} />
        </svg>
      );
    case "box":
      return (
        <svg viewBox="0 0 32 32" className={cn(className)}>
          <rect x="6" y="6" width="20" height="20" rx="2" fill={fill} opacity="0.3" stroke={stroke} strokeWidth="1.5" />
        </svg>
      );
    case "rug":
      return (
        <svg viewBox="0 0 32 32" className={cn(className)}>
          <rect x="4" y="8" width="24" height="16" rx="1.5" fill={fill} opacity="0.4" stroke={stroke} strokeWidth="1.5" strokeDasharray="2 2" />
        </svg>
      );
    case "lamp":
      return (
        <svg viewBox="0 0 32 32" className={cn(className)}>
          <path d="M11 8 L21 8 L19 14 L13 14 Z" fill={fill} opacity="0.4" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" />
          <line x1="16" y1="14" x2="16" y2="25" stroke={stroke} strokeWidth="1.5" />
          <line x1="11" y1="26" x2="21" y2="26" stroke={stroke} strokeWidth="1.5" />
        </svg>
      );
    case "plant":
      return (
        <svg viewBox="0 0 32 32" className={cn(className)}>
          <path d="M12 22 L10 14 L16 18 L22 14 L20 22 Z" fill={fill} opacity="0.5" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" />
          <path d="M16 18 L16 6" stroke={stroke} strokeWidth="1.5" />
          <rect x="11" y="22" width="10" height="5" rx="1" fill={stroke} opacity="0.6" />
        </svg>
      );
    case "square":
    default:
      return (
        <svg viewBox="0 0 32 32" className={cn(className)}>
          <rect x="7" y="7" width="18" height="18" rx="2" fill={fill} opacity="0.3" stroke={stroke} strokeWidth="1.5" />
        </svg>
      );
  }
}
